import { Typography } from "antd";

const { Title, Text } = Typography;

interface SummaryProps {
  serviceFee: number;
  cardOnFile?: boolean;
}

export const PaymentSummary: React.FC<SummaryProps> = ({
  serviceFee,
  cardOnFile = false,
}) => {
  return (
    <div className="mb-4">
      {cardOnFile ? (
        <Text strong>
          Your card will be charged ${serviceFee} if you complete this request
        </Text>
      ) : (
        <>
          <Title level={3}>Profile Creation and Identity Verification Fee</Title>
          <Text>Amount due: US${serviceFee}</Text>
          <br />
          <div className="fee-details">
            <p>This fee includes:</p>
            <ul>
              <li>Profile creation</li>
              <li>Certification of your Identification (ID) Form by an ECFMG-approved notary</li>
            </ul>
            <p>
              <a href="https://www.ecfmg.org/cvhp/" target="_blank" rel="noopener noreferrer">Additional fees</a> will be assessed if and when additional services are requested.
            </p>
          </div>
        </>
      )}
    </div>
  );
};
